import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';

export const ZyExploreNodeView = ({ selected, decorations }: ReactNodeViewProps) => {
    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="zyExplore"
            selected={selected}
            contentClassName="px-6 pt-6 pb-6"
        >
            <div
                className="mb-2"
                contentEditable={false}
            >
                Exploring further:
            </div>
            <NodeViewContent />
        </CommonNodeViewWrapper>
    );
};

export default ZyExploreNodeView;
